import React, { MouseEvent, PropsWithChildren } from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Flex from '../../../../../components/common/Flex'
import './nodeTemplate.css'

interface NodeTemplateProps extends PropsWithChildren {
  icon?: IconProp
  title: string
  name?: string
  color?: string
}

const NodeTemplate = ({
  icon,
  color,
  title,
  name,
  children,
}: NodeTemplateProps) => {
  return (
    <div
      className={'react-flow__node__content shadow-lg bg-transparent rounded'}
      style={{ backgroundColor: color }}
    >
      <Flex alignItems={'center'} className={'node_content p-0 rounded'}>
        <Flex
          alignItems={'center'}
          className={'icon_node_content align-self-stretch rounded-start'}
          justifyContent={'center'}
        >
          {icon && (
            <FontAwesomeIcon icon={icon} size={'2xl'} className={'me-1 ms-1'} />
          )}
        </Flex>
        <div className={'node_text p-3 bg-200 rounded-end w-100'}>
          <div className={'node_title text-dark-emphasis rounded-end '}>
            {title}
          </div>
          <div className={'node_name rounded-end text-900 '}>{name}</div>
        </div>
      </Flex>
    </div>
  )
}

export default NodeTemplate
